import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types/api';
import { ICustomerPlApiListResponse } from '@/types/customerPl';

export const customerPlList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/list', { ...config, params });
};

export const customerPlSportList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/sport', { ...config, params });
};

export const customerPlPeriodTypeList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/periodType', { ...config, params });
};

export const customerPlEventTypeList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/eventType', { ...config, params });
};

export const customerPlMarketList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/market', { ...config, params });
};

export const customerPlBookmakerList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/bookmaker', { ...config, params });
};

export const customerPlLeagueLimitsList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/leagueLimits', { ...config, params });
};

export const customerPlCustomLeagueList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomerPlApiListResponse>> => {
    return axios.get('/api/customerPL/customLeague', { ...config, params });
};
